import CardArticle from '../DiscoveryComponent/MiddleContentComponent/components/card-article.component';
import GoogleAd from '../GoogleAds';
import CardArticleLoading from '../DiscoveryComponent/MiddleContentComponent/components/card-article-loading.component';
import EmptyArticleComponent from '../EmptyArticleComponent';
import EmptyProfileState from '../../routes/Profile/components/EmptyProfileState';
import { profileAtom } from '../Settings/atom';
import { useAtom } from 'jotai';

const ArticleContainer = ({
  loading,
  listArticle,
  currentTopicId,
  isHiddenFeaturedArticles,
  type,
  isProfile
}) => {
  const [profile] = useAtom(profileAtom);
  const renderContentWithAds = () => {
    const contentWithAds = [];
    listArticle.forEach((item, index) => {
      contentWithAds.push(
        <CardArticle
          key={`article-${index}`}
          index={index}
          item={{
            ...item,
            nameCreator: item?.creator?.firstName ?? '',
            imgUrl: item?.creator?.imgUrl
          }}
          isHiddenFeaturedArticles={isHiddenFeaturedArticles}
          isProfile={profile.id === item?.creator?.id}
        />
      );
      if ((index + 1) % 4 === 0) {
        contentWithAds.push(
          <GoogleAd
            articleId={item?.id}
            key={`ad-${index}`}
            slot="1625116786"
            className="my-custom-ad !z-10"
          />
        );
      }
    });
    return contentWithAds;
  };

  return (
    <div className="pb-[30px] w-full">
      <div className="md:px-0 flex flex-col gap-[24px] 2xl:gap-[60px]">
        {renderContentWithAds()}
        {loading &&
          [...Array(3)].map((_, i) => (
            <CardArticleLoading
              key={i}
              index={i}
              isHiddenFeaturedArticles={isHiddenFeaturedArticles}
            />
          ))}

        {listArticle.length === 0 && !loading && isProfile && (
          <EmptyArticleComponent currentTopicId={currentTopicId} categoryType={type} />
        )}
        {listArticle.length === 0 && !loading && !isProfile && (
          <EmptyProfileState currentTopicId={currentTopicId} categoryType={type} />
        )}
      </div>
    </div>
  );
};

export default ArticleContainer;
